import { SortIcon } from '@sketchnote/icons';
import classNames from 'classnames';
import * as React from 'react';

import { isThirdElem } from '../../shared/utils';
import { LessonLoader } from '../loaders';
import { VideoCard } from '../video-card';
import { SortActiveTextProps } from './types';

const translations = {
  video_thumbnail_label: '',
};

export const EmptyState = ({
  src,
  contents,
  className,
  showVideo = true,
  thumbnailUrl = '',
  videoId = '',
  onClose,
}: {
  src: string;
  contents: string[];
  className?: string;
  showVideo?: boolean;
  thumbnailUrl?: string;
  videoId?: string;
  onClose?: () => void;
}) => {
  const imageClasses = classNames({
    'mb-8 mx-auto': true,
    [className || '']: !!className,
  });
  if (showVideo) {
    return (
      <div className="flex justify-center text-center bg-white p-24 text-gray-999 w-full">
        <div className="min-h-144 text-sm justify-center">
          <VideoCard
            translations={translations}
            thumbnailUrl={thumbnailUrl}
            videoId={videoId}
            className="bg-blue-700 w-400 justify-center align-middle mb-15"
            onClose={onClose}
          />
          {contents.map((obj, index) => (
            <p key={`${obj}${index}`}>{obj}</p>
          ))}
        </div>
      </div>
    );
  } else {
    return (
      <div className="flex justify-center text-center bg-white p-24 text-gray-999 w-full">
        <div className="min-h-144 text-sm justify-center">
          <img src={src} width="304px" height="150px" className={imageClasses} alt="" />
          {contents.map((obj, index) => (
            <p key={`${obj}${index}`}>{obj}</p>
          ))}
        </div>
      </div>
    );
  }
};

// eslint-disable-next-line react/prop-types
export const FootWrap = ({ children }) => (
  <div className="flex justify-center items-center relative">{children}</div>
);
// eslint-disable-next-line react/prop-types
export const BodyWrap = ({ children }) => (
  <div className="flex flex-wrap mt-6 mb-30">{children}</div>
);
// eslint-disable-next-line react/prop-types
export const ShowMoreBtn = ({ onClick, children }) => (
  <button className="absolute left-0 font-medium text-sm" onClick={onClick}>
    {children}
  </button>
);

export const SortActiveText = ({
  sortTxt,
  activeSortValue,
  isSortMenuOpened,
  icon = <SortIcon className="mr-5" />,
}: SortActiveTextProps): JSX.Element => (
  <span
    className={classNames({
      'flex items-center font-medium text-sm': true,
      'text-gray-999': isSortMenuOpened,
    })}
  >
    {icon}
    <span>{`${sortTxt} ${activeSortValue.label}`}</span>
  </span>
);

export const Loaders = (): JSX.Element => (
  <div className="flex flex-wrap">
    {Array(6)
      .fill('data')
      .map((data, index) => (
        <LessonLoader
          key={`${data}-${index}`}
          className={classNames({ 'mb-15': true, 'mr-15': !isThirdElem(index + 1) })}
        />
      ))}
  </div>
);
